import React, { useEffect, useRef, useState } from "react";
import { getDeviceSize } from "../../exports/InteractiveUtils";
import { priceFormat, formatSchemeName } from "../../exports/UtilFunctions";
import Badge from "../ui/badge";

const DEVICE_SIZE = getDeviceSize();

const FamilySipTable = ({ sipDetails }) => {
  const [transactions, setTransaction] = useState([]);
  const [showCeased, setShowCeased] = useState(false);

  const activeRows = transactions.filter((sip) => sip.Status === "Active");
  const ceasedRows = transactions.filter((sip) => sip.Status !== "Active");
  const ceasedRef = useRef(null);

  useEffect(() => {
    if (Array.isArray(sipDetails)) {
      setTransaction(sipDetails);
    } else {
      setTransaction([]);
    }
  }, [sipDetails]);

  return (
    <>
      <div className="family-stocks-table">
        {!transactions || transactions.length === 0 ? (
          <></>
        ) : (
          <>
            {DEVICE_SIZE === "S" ? (
              <>
                {activeRows.map((h, index) => {
                  return (
                    <InvestMentCard
                      key={index}
                      data={h}
                      // handleBuy={handleBuy}
                      // handleSell={handleSell}
                    />
                  );
                })}
                {showCeased &&
                  ceasedRows.map((h, index) => {
                    return (
                      <div key={index} ref={index === 0 ? ceasedRef : null}>
                        <InvestMentCard data={h} />
                      </div>
                    );
                  })}
              </>
            ) : (
              <>
                <table className="family-mf-table">
                  <thead>
                    <tr>
                      <td className="scheme-name">Scheme Name</td>
                      <td className="">ISIN</td>
                      <td className="">Folio No</td>
                      <td className="category">Category</td>
                      <td className="">Amount</td>
                      <td className="">Installments</td>
                      {/* <td className="">Completed</td> */}
                      <td>Frequencys</td>
                      <td className="">Day</td>
                      {/* <td className="">First Inst.</td> */}
                      <td className="">Last Inst.</td>
                      <td className="">Status</td>
                    </tr>
                  </thead>
                  <tbody className="">
                    {activeRows.map((h, index) => (
                      <tr key={`active-${index}`} className="yes_hover">
                        <td>{h["SchemeName"]}</td>
                        <td>{h["ISIN"]}</td>
                        <td>{h["FolioNumber"]}</td>
                        <td className="body-category">{h["Category"]}</td>
                        <td>{priceFormat(h["Amount"])}</td>
                        <td>
                          {h["Completed"]} out of {h["Installments"]}
                        </td>
                        {/* <td>{h["Completed"]}</td> */}
                        <td>{h["Frequency"]}</td>
                        <td>{h["DayOfMonth"]}</td>
                        {/* <td>{h["FirstInstallment"]}</td> */}
                        <td>{h["LastInstallment"]}</td>
                        <td className="positive">{h.Status}</td>
                      </tr>
                    ))}

                    {showCeased &&
                      ceasedRows.map((h, index) => (
                        <tr
                          key={`ceased-${index}`}
                          className="yes_hover"
                          ref={index === 0 ? ceasedRef : null}
                        >
                          <td>{h["SchemeName"]}</td>
                          <td>{h["ISIN"]}</td>
                          <td>{h["FolioNumber"]}</td>
                          <td>{h["Category"]}</td>
                          <td>{priceFormat(h["Amount"])}</td>
                          <td>
                            {h["Completed"]} out of {h["Installments"]}
                          </td>
                          <td>{h["Frequency"]}</td>
                          <td>{h["DayOfMonth"]}</td>
                          {/* <td>{h["FirstInstallment"]}</td> */}
                          <td>{h["LastInstallment"]}</td>
                          <td>{h["Status"]}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </>
            )}
          </>
        )}
      </div>
      <div className="portfolio-mfwc-buttons" style={{ marginTop: "10px" }}>
        <button
          className="hover-btn hover-input-btn"
          onClick={() => setShowCeased(!showCeased)}
        >
          {showCeased
            ? "Hide Ceased SIPs"
            : `Show Ceased SIPs (${ceasedRows.length})`}
        </button>
      </div>
    </>
  );
};

function InvestMentCard({ data }) {
  const {
    FolioNumber,
    Category,
    SchemeName,
    Amount,
    Installments,
    Completed,
    Frequency,
    FirstInstallment,
    Status,
  } = data;

  const [newSchemeName, setNewSchemeName] = useState(null);

  useEffect(() => {
    if (SchemeName) {
      setNewSchemeName(formatSchemeName(SchemeName));
    }
  }, [SchemeName]);

  return (
    <div className="mf-watchlist-card">
      <div className="mfwc-config">
        <div className="mfwc-config-row">
          <p className="mfwc-title-row">
            <p className="name">{newSchemeName}</p>
            <p className="category">
              {Category},&nbsp;Folio: {FolioNumber}
            </p>
          </p>
          <p
            className="value"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            {priceFormat(Amount)} <br />
            <Badge
              variant={Status === "Active" ? "success" : "error"}
              size="xxxs"
            >
              {Status}
            </Badge>
          </p>
        </div>
        <div className="mfwc-config-row">
          <p>
            Installments&nbsp;-&nbsp;
            <span>
              {Completed}&nbsp;/&nbsp;{Installments},&nbsp;{Frequency}
            </span>
          </p>
          <p>
            Last Intallment&nbsp;-&nbsp;
            <span>{FirstInstallment}</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default FamilySipTable;
